export default function SmartContractAudit() {
  return (
    <section className="relative pt-32 pb-20 px-4 z-10">
      <div className="max-w-5xl mx-auto flex flex-col items-center gap-8">

        {/* Logo */}
        <img
          src="https://static.lumi.new/9c/9c1ccefd81b9dbb855ed621cfae893f3.webp"
          alt="Smart Contract Audit Logo"
          className="w-64 sm:w-80 md:w-96 h-auto object-contain"
        />

        {/* Tagline */}
        <p className="text-xl sm:text-2xl md:text-3xl font-semibold text-white text-center">
          Audit your token. Earn trust on-chain.
        </p>

        {/* Main Image */}
        <div className="w-full rounded-2xl overflow-hidden shadow-[0_0_50px_rgba(255,255,255,0.15)] hover:shadow-[0_0_70px_rgba(255,255,255,0.25)] transition-all duration-300">
          <img
            src="https://static.lumi.new/0a/0a87661ed62f774b7ffe0f6607fc98d9.webp"
            alt="Smart Contract Audit"
            className="w-full h-auto object-contain"
          />
        </div>

        {/* Coming Soon */}
        <p className="text-lg sm:text-xl text-gray-300 text-center tracking-wide">
          EVM Smart Contract Security Coming Soon
        </p>

      </div>
    </section>
  )
}
